module.exports = __webpack_public_path__ + "static/media/10_4.6380ed85.png";